import template from './navbar.html';
import controller from './navbar.controller';
import './navbar.styl';

let navbarComponent = {
  restrict: 'E',
  bindings: {
    hideGlobalFilters: '<',
    globalFilterOptions: '<',
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default navbarComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/navbar/navbar.component.js
 **/